import type { BriefingReportPageData } from "content-ui/briefings/fetchers/briefingReportFetcher";

import Heading from "content-ui/briefings/components/briefingsReports/elements/heading";
import CardContainer from "content-ui/briefings/components/briefingsReports/elements/cardContainer";
import { MarkdownTracked } from "components/markdownTracked/markdownTracked";

const TrendsCard = ({
  briefing,
  id,
}: {
  briefing: BriefingReportPageData;
  id: string;
}) => {
  return (
    <CardContainer id={`content__${id}`}>
      <Heading text={briefing.trendsToWatchHeading} id={id} />
      <ol className="flex flex-col gap-[16px] md:mt-[16px] md:gap-[32px]">
        {briefing.trends.map((trend, i) => (
          <li key={i} className="md:rounded-[2px] md:p-[12px]">
            <p className="text-[16px] font-[700] text-[#002EA5] md:text-[24px]">
              {trend.heading}
            </p>
            <MarkdownTracked
              text={trend.body}
              className="ml-[30px] mt-[8px] list-disc text-[16px] md:mt-[16px] md:ml-[40px] md:text-[21px]"
              component="Trends"
            />
          </li>
        ))}
      </ol>
    </CardContainer>
  );
};

export default TrendsCard;
